import { fg } from '@atlaskit/platform-feature-flags/fg';

export type ChatSurface = 'new-tab' | 'sidebar' | 'floaty' | 'full-page';

/**
 * Resolves which chat convergence surface should be served.
 *
 * Exactly one surface is served at a time. When several gates are on, the highest-priority
 * surface wins in this order:
 *
 *   new tab > sidebar > floaty > full page
 *
 * `chatIntentDetectionEnabled` is true whenever *any* surface is served, and is what gates
 * whether the Quick Find chat intent row renders at all.
 */
export const serveChatConvergenceExperiment = (): {
	chatIntentDetectionEnabled: boolean;
	chatSurface: ChatSurface | undefined;
} => {
	const fullPageChatEnabled = fg('rovo_search_chat_convergence');
	const newTabChatEnabled = fg('rovo_search_chat_convergence_tab');
	const sidebarChatEnabled = fg('rovo_search_chat_convergence_sidebar');
	const floatyChatEnabled = fg('rovo_search_chat_convergence_floaty');

	let chatSurface: ChatSurface | undefined;
	if (newTabChatEnabled) {
		chatSurface = 'new-tab';
	} else if (sidebarChatEnabled) {
		chatSurface = 'sidebar';
	} else if (floatyChatEnabled) {
		chatSurface = 'floaty';
	} else if (fullPageChatEnabled) {
		chatSurface = 'full-page';
	}

	return {
		chatIntentDetectionEnabled: chatSurface !== undefined,
		chatSurface,
	};
};
